
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance",
      function () {
        return require("private-next-pages/compliance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance"])
      });
    }
  